import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import LanguageSwitch from "./LanguageSwitch";
import { WHATSAPP_LINK } from "@/mocks/restaurant";

export default function Header() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  const nav = [
    { label: t("nav.recommended"), href: "#recomendados" },
    { label: t("nav.hours"), href: "#horario" },
    { label: t("nav.directions"), href: "#como-llegar" },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${
        scrolled
          ? "border-b border-background-300/60 bg-background-50/95 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <div className="flex h-16 items-center justify-between gap-3 px-4 md:h-20 md:px-10">
        <a href="#top" aria-label="MÂJI by Cerón, inicio" className="cursor-pointer">
          <Logo />
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Navegación principal">
          {nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer font-body text-sm tracking-wide text-secondary-500 transition-colors hover:text-primary-500"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <LanguageSwitch />
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="press inline-flex min-h-[44px] items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 font-body text-sm text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer md:px-5"
          >
            <i className="ri-whatsapp-fill text-lg" aria-hidden="true" />
            <span className="hidden sm:inline">{t("header.whatsapp")}</span>
          </a>
        </div>
      </div>
    </header>
  );
}